import { useEffect, useState } from 'react';
import ComplianceCard from '../../components/common/ComplianceCard';
import complianceApi from '../../api/complianceApi';
import {
  encodeDateForUrl,
  getAdjustedDate,
  getDaysFromToday,
} from '../../utils/dateUtils';
import useDateStore from '../../store/selectedDateStore';
import useLocationStore from '../../store/locatonStore';
import UpComingStaffCompliance from '../../components/common/UpComingStaffCompliance';
import AirCraftComplianceList from '../../components/common/AirCraftComplianceList';
import PilotHoursList from '../../components/common/PilotHoursList';
import DriverHourList from '../../components/common/DriverSummaryList';
import { BallTriangle } from 'react-loader-spinner';
import useUserStore from '../../store/userStore';
import useBgColorStore from '../../store/bgColor';
import VeichleAndComplianceList from '../../components/common/VeichleComplianeList';
import { translate } from '../../i18n';

export default function ComplianceMobile() {
  const { selectedDateFromStore, setSelectedDateFromStore } = useDateStore();
  const id = useUserStore((state) => state?.user?.id);
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const [apiResponse, setApiResponse] = useState<any>();
  const [selectedDate, setSelectedDate] = useState<Date>(
    selectedDateFromStore || getAdjustedDate(),
  );
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchComplianceDetails();
  }, [selectedDate, selectedLocation.OwnerId]);

  const fetchComplianceDetails = async () => {
    try {
      setLoading(true); // ✅ Set before fetch
      const encodedDate = encodeDateForUrl(selectedDate);
      const response = await complianceApi.getComplianceDetails(
        selectedLocation.OwnerId,
        encodedDate,
        id,
      );
      setApiResponse(response?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // ✅ Stop loader
    }
  };

  const { bgColor } = useBgColorStore();
  return (
    <>
      <div className="w-screen h-screen p-4 bg-backgroundColor-darkThemeColor flex flex-col">
        <ComplianceCard
          userName={
            Array.isArray(apiResponse?.staffDetails?.staffName)
              ? apiResponse?.staffDetails?.staffName[0]
              : apiResponse?.staffDetails?.staffName
          }
          passwordExpiresIn={getDaysFromToday(
            apiResponse?.staffDetails?.expiryDate || '',
          )}
          lastLogin={apiResponse?.staffDetails?.lastLogon}
        />

        {loading ? (
          <div className="flex flex-1 justify-center items-center">
            <BallTriangle
              height="80"
              width="80"
              color="#4fa94d"
              ariaLabel="loading"
              visible={true}
            />
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto">
            {apiResponse?.upcomingStaffCompliance?.upcomingStaffCompliance
              ?.length > 0 && (
              <UpComingStaffCompliance
                upcomingStaffCompliance={
                  apiResponse?.upcomingStaffCompliance
                    ?.upcomingStaffCompliance || []
                }
                userCanEditStaffCompliance={
                  apiResponse?.upcomingStaffCompliance
                    ?.userCanEditStaffCompliance || false
                }
                refetchComplianceDetails={fetchComplianceDetails}
                userHavePermissionToUpdateStatusStaffCompliance={
                  apiResponse?.upComingStaffCompliance
                    ?.userHavePermissionToUpdateStatusStaffCompliance
                }
                userHavePermissionToReadStatusStaffCompliance={
                  apiResponse?.upcomingStaffCompliance
                    ?.userHavePermissionToReadStatusStaffCompliance
                }
              />
            )}

            {apiResponse?.vehicleAndTrailer?.vehicleAndTrailer?.length > 0 &&
              apiResponse?.vehicleAndTrailer
                ?.userHavePermissionToViewVeichleCompliance && (
                <VeichleAndComplianceList
                  complianceData={
                    apiResponse?.vehicleAndTrailer?.vehicleAndTrailer
                  }
                  refetchComplianceDetails={fetchComplianceDetails}
                  editPermissionForVeichleCompliance={
                    apiResponse?.vehicleAndTrailer
                      ?.readPermissionForVeichleCompliance
                  }
                />
              )}

            {apiResponse?.aircraft?.aircraft?.length > 0 &&
              apiResponse?.aircraft
                ?.userHavePermissionToViewAirCraftCompliance && (
                <AirCraftComplianceList
                  complianceData={apiResponse?.aircraft?.aircraft}
                  writePermissionForEquipmentCompliance={
                    apiResponse?.aircraft?.writePermissionForEquipmentCompliance
                  }
                  refetchComplianceDetails={fetchComplianceDetails}
                  editPermissionForBalloonCompliance={
                    apiResponse?.aircraft?.editPermissionForBalloonCompliance
                  }
                />
              )}

            {apiResponse?.pilotSummary?.length > 0 && (
              <PilotHoursList pilotSummary={apiResponse?.pilotSummary || []} />
            )}

            {apiResponse?.driverSummary?.length > 0 && (
              <DriverHourList
                driverSummary={apiResponse?.driverSummary || []}
              />
            )}

            {apiResponse?.staffDetails &&
              !apiResponse?.upcomingStaffCompliance?.upcomingStaffCompliance
                ?.length &&
              !apiResponse?.vehicleAndTrailer?.vehicleAndTrailer?.length &&
              !apiResponse?.aircraft?.aircraft?.length &&
              !apiResponse?.pilotSummary?.length &&
              !apiResponse?.driverSummary?.length && (
                <div
                  className={`flex justify-center items-center ${bgColor}  rounded-md shadow-sm h-full`}
                >
                  <p className="text-text-blue text-base font-medium text-center">
                    {translate('complianceNote.noData')}
                  </p>
                </div>
              )}
          </div>
        )}
      </div>
    </>
  );
}
